export const MemberFormTabs = {
    MEMBER_INFO: 'member-info',
    BOX: 'box',
    NOTIFICATIONS: 'notifications',
    SPLASHES: 'splashes',
}
